export enum InstallerBadge {
  BestDeal = 'best_deal',
  GreatDeal = 'great_deal',
  FairDeal = 'fair_deal',
  NABCEP = 'NABCEP',
  BBB = 'BBB',
}

type AuroraTenant = {
  aurora_env: string;
  aurora_tenant_id: string;
  aurora_tenant_name: string;
};

export type InstallerMeta = {
  _id: string;
  name: string;
};

// Renamed from MongoDB collection "Partner"
export type Installer = {
  _id: string;
  about_us: string;
  address: string;
  address2: string;
  aurora_tenants: AuroraTenant[];
  badges: string[];
  city: string;
  coords?: { lat: number; lng: number };
  email: string;
  founded: number;
  google_review_count?: number;
  heliose_review: string;
  hours?: Hours;
  lead_notify?: string[];
  lead_text_notify?: string[];
  logo_image: string;
  marketplace_enabled: boolean;
  mp_end_date?: string;
  name: string;
  num_emp?: number;
  phone: string;
  rating?: number;
  rating_count?: number; // TODO make required once Platform populates this field
  reviews?: string[];
  service_areas: string[];
  state: string;
  travel_adder_provider?: string;
  tz: string;
  unlaunched?: string;
  updated?: string;
  url: string;
  zip: string;
};

export type PanelHardware = {
  display_name: string;
  hardware_id: string;
  name: string;
  part_number: string;
  type: string;
  watts: number;
};

export type BatteryHardware = {
  capacity: number;
  display_name: string;
  hardware_id: string;
  name: string;
  part_number: string;
  type: string;
};

type Hours = {
  business: {
    fri: DayHours;
    mon: DayHours;
    sat: DayHours;
    sun: DayHours;
    thu: DayHours;
    tue: DayHours;
    wed: DayHours;
  };
  call: {
    fri: DayHours;
    mon: DayHours;
    sat: DayHours;
    sun: DayHours;
    thu: DayHours;
    tue: DayHours;
    wed: DayHours;
  };
  install: {
    fri: DayHours;
    mon: DayHours;
    sat: DayHours;
    sun: DayHours;
    thu: DayHours;
    tue: DayHours;
    wed: DayHours;
  };
};

type DayHours = {
  end?: { h: number; m: number };
  start?: { h: number; m: number };
};
